export default "__VITE_ASSET__7a9fbec9__"